export class IdiomaVO {
    descripcion: string;
    id: number;
    idNombre: string;
}